var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H40.5V36.5H0.5V0.5Z",
    fill: "#8297CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15.6016C30.1602 15.1836 30.25 14.7266 30.25 14.25C30.25 12.1797 28.5703 10.5 26.5 10.5C25.7305 10.5 25.0117 10.7344 24.418 11.1328C23.3359 9.25781 21.3164 8 19 8C15.5469 8 12.75 10.7969 12.75 14.25C12.75 14.3555 12.7539 14.4609 12.7578 14.5664C10.5703 15.3359 9 17.4219 9 19.875C9 22.9805 11.5195 25.5 14.625 25.5H29C31.7617 25.5 34 23.2617 34 20.5C34 18.082 32.2812 16.0625 30 15.6016ZM24.8086 19.0664L20.6914 23.1836C20.4492 23.4258 20.0508 23.4258 19.8086 23.1836L15.6914 19.0664C15.2969 18.6719 15.5781 18 16.1328 18H18.6875V13.625C18.6875 13.2812 18.9688 13 19.3125 13H21.1875C21.5312 13 21.8125 13.2812 21.8125 13.625V18H24.3672C24.9219 18 25.2031 18.6719 24.8086 19.0664Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.93a95ba311fbf0cbb1131f7342c113f0.svg";
export { ForwardRef as ReactComponent };